module.exports = __webpack_public_path__ + "img/diya.230fd7c2.png";